import { html, nothing, TemplateResult } from 'lit';
import type { ImageRenderData } from '../utils/gallery.utils.js';

/**
 * Shared <img> template used across all gallery views (teaser, overlay grid, fullscreen).
 * @param image - Render data with src, srcset, alt
 * @param loading - Browser loading hint
 * @param onLoad - Optional load callback
 * @param tabIndex - Optional tab index for views where the image itself must not receive focus
 * @returns TemplateResult
 */
export function galleryImageTemplate(
    image: ImageRenderData,
    loading: 'eager' | 'lazy' = 'lazy',
    onLoad?: (event: Event) => void,
    tabIndex?: number
): TemplateResult {
    return html`
        <img
            src="${image.src}"
            alt="${image.alt}"
            srcset=${image.srcset || nothing}
            sizes="(max-width: 600px) 100vw, (max-width: 1024px) 50vw, 33vw"
            decoding="async"
            loading="${loading}"
            tabindex=${tabIndex ?? nothing}
            @load=${onLoad}
        />
    `;
}
